export const environment = {
  app: false,
  appVersion: '0',
  android: false,
  ios: false,
  dev: false,
  stage: false,
  production: true,
  tokenKey: 'pt',
  APIBaseUrl: 'https://services.pickright.in',
  SocketUrl: 'https://services.pickright.in',
  ZerodhaAPIToken: '5d3l4jbzhtvuuabu',
  webUrl: 'https://pickright.in',
  pickRightAdvisor: '60212628fcf0997e93910424',
  wealthTrustAdvisor: '60212628fcf0997e93910424',
  firebase: {
    "projectId":"pickright-75318",
    "appId":"1:947485606367:web:62947d4e80c372a429046a",
    "databaseURL":"https://pickright-75318.firebaseio.com",
    "storageBucket":"pickright-75318.appspot.com",
    "apiKey":"AIzaSyC7YJl_VtWaEqVoPBDNGy-yfgPrPh3EUM8",
    "authDomain":"pickright-75318.firebaseapp.com",
    "messagingSenderId":"947485606367",
    "measurementId":"G-GD3HZLWCNV"
  },
  googleTagID: "GTM-5G67Z8P",
  expertPost: '61a5dfd0fc459618ce957da8',
  mixPanelToken: '6612acc294fa710132de04a9ab454541',
  verticalToken: "userVertical",
  upgradingExperience: {
    trading: false
  },
  facebookAppId: "250348152985405",
  GTM_ID: "G-GD3HZLWCNV",
  FBPixelAppId: "872894891473959",
    SAPDomain: "pickright.in"
};